module.exports = __webpack_public_path__ + "img/discord_a.92fb760e.svg";